const BUILD_ID = process.env.GATSBY_BUILD_ID || 'dev';

export const log = (message: string, data?: any) => {
  if (BUILD_ID !== 'production') {
    if (data) {
      console.debug(message, data);
    } else {
      console.debug(message);
    }
  }
};
